module.exports = __webpack_public_path__ + "img/diners-1.b35662a1.png";